import { PatchedFieldsContext } from 'components/common-form/contexts/PatchedFieldsContext';
import { useContext, useMemo } from 'react';
import { buildPatchedCellKey } from 'state/formData/patchedFields/extractors';
import { getPatchedFieldClassName } from 'state/formData/patchedFields/patchedFields.helper';

type CellHighlightResolver = (rowIndex: number, columnId: string) => string | undefined;

/** Per-cell counterpart of {@link usePatchedFieldHighlight}; returns `undefined` for cells that are not patched. */
export function useGridPatchedCells(gridId: string): CellHighlightResolver {
  const { fields, pulseParity } = useContext(PatchedFieldsContext);

  return useMemo<CellHighlightResolver>(() => {
    const fieldsSet = new Set(fields);
    return (rowIndex, columnId) => {
      const key = buildPatchedCellKey(gridId, rowIndex, columnId);
      if (!fieldsSet.has(key)) {
        return undefined;
      }
      return getPatchedFieldClassName(pulseParity, key);
    };
  }, [gridId, fields, pulseParity]);
}
